import { render, staticRenderFns } from "./baidu_tongji.vue?vue&type=template&id=68d0d33a&scoped=true&"
import script from "./baidu_tongji.vue?vue&type=script&lang=js&"
export * from "./baidu_tongji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0d33a",
  null
  
)

export default component.exports